// extracted by mini-css-extract-plugin
export default {"root":"styles_root__Rv-lp","menu":"styles_menu__TggOW"};